module.exports = __webpack_public_path__ + "img/bj_tx@2x.4e98d2e3.png";